import {
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import * as productService from "../../../services/productService";
import { RootState } from "../store";
import { ProductItem } from "../../../models/product/product";

const initialState: ProductItem[] = [];

export const productSlice = createSlice({
    name: "product",
    initialState: initialState,
    reducers: {
        setProducts: (_, action: PayloadAction<ProductItem[]>) => {
            return [...action.payload];
        }
    },
});

export const { setProducts } = productSlice.actions;

export const getOwnerProducts = createAsyncThunk(
    "products/list",
    async(_, thunkApi) => {
        const res = await productService.getProducts(thunkApi.signal);
        thunkApi.dispatch(setProducts(res.data));
    }
);

export const productReducer = productSlice.reducer;

export const selectProducts = (state: RootState) : ProductItem[] => state.product;
